import PropTypes from 'prop-types'

import { useOutpost } from '../OutpostProvider/OutpostProvider'

const IfOutpost = ({ children }) => {
  const { isOutpost } = useOutpost()
  return isOutpost && children !== undefined ? children : null
}

IfOutpost.propTypes = {
  children: PropTypes.node
}

const UnlessOutpost = ({ children }) => {
  const { isOutpost } = useOutpost()
  return !isOutpost && children !== undefined ? children : null
}

UnlessOutpost.propTypes = {
  children: PropTypes.node
}

export { IfOutpost, UnlessOutpost }
